import axios from "axios";
import { dispatch } from "store";
import { logout } from "store/user";
const CMS_HOST = process.env.REACT_APP_CMS_HOST || "http://localhost:1337";
const CMS_API_PATH = process.env.REACT_APP_CMS_API_PATH || "/api";

const baseURL = `${CMS_HOST}${CMS_API_PATH}`;

const client = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// add bearer token to request headers
client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

client.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (401 === error.response.status) {
      localStorage.removeItem("user");
      localStorage.removeItem("authToken");
      dispatch(logout());
      return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  }
);

export default client;
